exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-link{font-size:1.4rem;font-weight:700}.product-link a{color:#367c2b}.cf .product-link a,.hitachi .product-link a{color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/shared/components/product-link.scss
// module id = 5152
// module chunks = 0